import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { MONTHS } from '../../config/settings/constant'
import { getPurchaseOrders } from '../../services/purchaseOrder'

export const GET_TOTAL_PURCHASE_ORDERS = 'GET_TOTAL_PURCHASE_ORDERS'
export const GET_TOTAL_PURCHASE_ORDERS_ERROR = 'GET_TOTAL_PURCHASE_ORDERS_ERROR'
export const GET_TOTAL_PURCHASE_ORDERS_SUCCESS = 'GET_TOTAL_PURCHASE_ORDERS_SUCCESS'
export const onGetTotalPurchaseOrders = makeActionCreator(GET_TOTAL_PURCHASE_ORDERS)
export const onGetTotalPurchaseOrdersError = makeActionCreator(GET_TOTAL_PURCHASE_ORDERS_ERROR, 'payload')
export const onGetTotalPurchaseOrdersSuccess = makeActionCreator(GET_TOTAL_PURCHASE_ORDERS_SUCCESS, 'payload')
export const onGetTotalPurchaseOrdersThunk = payload => async dispatch => {
  dispatch(onGetTotalPurchaseOrders())

  try {
    const {
      data: { payload: responsePayload }
    } = await getPurchaseOrders({ actionType: GET_TOTAL_PURCHASE_ORDERS, dni: payload })

    const { data: purchaseOrders, periodo, total } = responsePayload

    const rangeDate = {
      initialtMonth: MONTHS[periodo.mesInicial - 1],
      initialYear: periodo.añoInicial,
      finalMonth: MONTHS[periodo.mesFinal - 1],
      finalYear: periodo.añoFinal
    }

    return dispatch(
      onGetTotalPurchaseOrdersSuccess({
        hasData: purchaseOrders.length > 0,
        purchaseOrders: purchaseOrders
          .filter(item => item.nro_oc > 0)
          .map(item => {
            return {
              amount: item.amount,
              name: item.name,
              totalOC: item.nro_oc,
              percentage: item.percentage
            }
          }),
        rangeDate,
        total
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetTotalPurchaseOrdersError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
